var render = function render(){var _vm=this,_c=_vm._self._c;return _c('portal',{attrs:{"to":_vm.globalTarget}},[(_vm.show)?_c('div',{class:['v-alert-global', _vm.themeClass]},[_c('div',{staticClass:"v-alert-global__container container-fluid pr-2"},[_c('div',{class:[
          'v-alert-global__content',
          _vm.themeClass,
          { 'has-icon': _vm.dismissible }
        ]},[_vm._t("default")],2),_c('div',{class:['v-alert-global__icon', _vm.themeClass]},[(_vm.dismissible)?_c('svg-icon',{attrs:{"close":""},on:{"click":function($event){return _vm.dismiss()}}}):_vm._e()],1)])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }